






































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { NotificationDto } from 'water-rest/src/model/messaging/NotificationDto';
import { declination } from '@/services/text-service';

@Component({})
export default class NotificationReadCriticalModal extends Vue {
  @Prop() private message!: NotificationDto;
  @Prop() private isSummary!: boolean;
  @Prop() private count!: number;

  declination!: (number: number, words: string[]) => string;

  get notificationCount() {
    return `${this.count} ${declination(this.count || 0, [
      'непрочитанное критическое оповещение',
      'непрочитанных критических оповещения',
      'непрочитанных критических оповещений',
    ])}`;
  }

  onTarget() {
    if (this.message?.target) {
      window.open(this.message.target, '_blank', 'noreferrer');
    }
    this.onClose();
  }

  onClose() {
    this.$rir.modal.close(false, false);
  }
}
